<template>
  <div class="pages">
    <div class="box">
      <div class="txt">请前往app中查看支付结果！</div>
      <!-- <div class="btn">点击前往</div> -->
    </div>
    
  </div>
</template>
<script>

export default {
  data () {
    return {
    }
  },
  created () {
    
  },

  methods : {
  }
  
}
</script>

<style scoped lang="less">
  .pages{
    min-height: 100%;
    display:  flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;

  }
  .box{
    text-align: center;
  }
  .btn{
    margin-top: 20px;
    text-decoration:underline;
    color: #2a34f6;
  }
</style>
